(() => {
  const policy = document.querySelector('#halo-term-condition-popup .halo-popup-content');
  if (!policy) return;
  const brand = /(?<![A-Za-z0-9_.@/\-])alwanalsahel(?![A-Za-z0-9_@/\-]|\.[A-Za-z0-9])/gi;
  const walker = document.createTreeWalker(policy, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (node.parentElement.closest('script, style')) continue;
    nodes.push(node);
  }
  nodes.forEach(node => {
    const parts = node.nodeValue.split(brand);
    if (parts.length === 1) return;
    const fragment = document.createDocumentFragment();
    parts.forEach((part, index) => {
      if (index) {
        fragment.append(document.createTextNode('ألوان الساحل '));
        const name = document.createElement('bdi');
        name.dir = 'ltr';
        name.className = 'alwan-policy-brand';
        name.textContent = '(Alwan Alsahel)';
        fragment.append(name);
        if (/^\p{Script=Arabic}/u.test(part)) fragment.append(document.createTextNode(' '));
      }
      fragment.append(document.createTextNode(part));
    });
    node.replaceWith(fragment);
  });
})();
